export const actions = {
  notifications: {
    RESET: 'NOTIFICATION_RESET',
  },
  errors: {
    RESET: 'ERRORS_RESET',
  },
  action: {
    DISPATCH_ACTION: 'DISPATCH_ACTION',
    GET_INSTRUMENT_BEHAVIOUR_ACTIONS: 'GET_INSTRUMENT_BEHAVIOUR_ACTIONS',
  },
};
